import React from 'react';
import { rankWith, isControl, scopeEndsWith, and } from '@jsonforms/core';

export const dynamicTester = (path: string) =>
  rankWith(
    3, // rank should be higher than the default renderers
    and(isControl, scopeEndsWith(path))
  );
